import FeedbackLayout from "./pages/FeebackLayout";
import FeedbackReportPage from "./pages/FeedbackReportPage";

export const feedbackRoutes = {
  path: "feedback",
  component: FeedbackLayout,
  redirect: {
    name: 'FeedbackReportPage'
  },
  children: [
    {
      name: "FeedbackReportPage",
      path: "",
      component: FeedbackReportPage
    }
  ]
};
